// detailed explanation provided on:
// https://team-1626860771808.atlassian.net/browse/OSCWEB-3703

import { DEFAULT_PAGE_SIZE } from "~/components/products-layout/constants";
import { Nullable } from "~/types/general.types";

export interface ClickAndCollectTags {
  clickAndCollect?: boolean;
  clickAndCollectExclusive?: boolean;
}

export const getProductCardIndexOnPage = (
  productToPageMap: Map<string, number> | undefined,
  productCode?: Nullable<string> | undefined,
): number | undefined => {
  if (!productCode) {
    return undefined;
  }

  const page = productToPageMap?.get(productCode);
  if (typeof page === "undefined") {
    return undefined;
  }
  const keysForPage = productToPageMap
    ? Array.from(productToPageMap)
        .filter(([, value]) => value === page)
        .map(([key]) => key)
    : [];

  const indexInPage = keysForPage.indexOf(productCode);
  if (indexInPage === -1) {
    return undefined;
  }

  // +1 so that the product index starts from 1
  return (page - 1) * DEFAULT_PAGE_SIZE + indexInPage + 1;
};

export const getClickAndCollectTagsForAllVariants = (
  variants: ClickAndCollectTags[],
): Required<ClickAndCollectTags> => {
  let clickAndCollectExclusiveTagsCount = 0;

  for (const variant of variants) {
    if (variant.clickAndCollect) {
      return {
        clickAndCollect: true,
        clickAndCollectExclusive: false,
      };
    }

    if (variant.clickAndCollectExclusive) {
      clickAndCollectExclusiveTagsCount++;
    }
  }

  if (clickAndCollectExclusiveTagsCount === variants.length) {
    return {
      clickAndCollect: false,
      clickAndCollectExclusive: true,
    };
  }

  if (clickAndCollectExclusiveTagsCount > 0) {
    return {
      clickAndCollect: true,
      clickAndCollectExclusive: false,
    };
  }

  return {
    clickAndCollect: false,
    clickAndCollectExclusive: false,
  };
};
